module.exports = __webpack_public_path__ + "static/media/atmosphere-fahrenheit-medical-svgrepo-com.ea1c9897.svg";